import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Milestone, Project } from '../schemas';
import { Auth } from '../service';
import { InvoiceForm, InvoiceFormData } from './invoice-form';
import { MilestoneForm, MilestoneFormData } from './milestone-form';
import { RemoveMilestoneData, RemoveMilestoneDialog } from './remove-milestone-dialog';

@Component({
  selector: 'lcm-milestone-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTableModule, MatIconModule, MatButtonModule, MatTooltipModule, DatePipe, DecimalPipe, MatToolbarModule],
  templateUrl: './milestone-table.html',
})
export class MilestoneTable {
  milestoneStatuses = {
    0: 'Not ready to invoice',
    10: 'Ready to invoice',
    20: 'Invoiced',
  };

  ownerId = input.required<string>();
  projects = input<Project[]>([]);

  now = signal(new Date().toISOString());

  auth = inject(Auth);
  dialog = inject(MatDialog);
  removed = output();
  saved = output();
  columnsToShow = signal(['Name', 'Notes', 'IntValue', 'Value', 'DueDate', 'PurchaseOrder', 'Invoicing', 'actions']);

  source = input.required<Milestone[]>();
  trackBy(idx: number, row: Milestone) {
    return row.Id;
  }

  pending = input(false);

  remove(item: Milestone) {
    const data: RemoveMilestoneData = {
      item,
      ownerId: this.ownerId(),
    };
    this.dialog
      .open(RemoveMilestoneDialog, { data })
      .afterClosed()
      .subscribe({
        next: (result) => result && this.removed.emit(),
      });
  }

  edit(item: Milestone) {
    const data: MilestoneFormData = {
      item,
      title: 'Update milestone',
      ownerId: this.ownerId(),
      projects: this.projects(),
    };
    this.dialog
      .open(MilestoneForm, { data })
      .afterClosed()
      .subscribe({
        next: (result) => result && this.saved.emit(),
      });
  }

  invoice(item: Milestone) {
    const data: InvoiceFormData = {
      item,
      ownerType: 'product',
      ownerId: this.ownerId(),
      projects: this.projects(),
    };
    this.dialog
      .open(InvoiceForm, { data })
      .afterClosed()
      .subscribe({
        next: (result) => result && this.saved.emit(),
      });
  }
}
